import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles, mergeClasses, Subtitle2, tokens, } from '@fluentui/react-components';
const useStyles = makeStyles({
    card: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        backgroundColor: tokens.colorNeutralBackground1,
        border: `1px solid ${tokens.colorNeutralStroke3}`,
        borderRadius: tokens.borderRadius3XLarge,
        boxShadow: tokens.shadow2,
        overflow: 'hidden',
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: tokens.spacingHorizontalM,
        padding: `${tokens.spacingVerticalL} ${tokens.spacingHorizontalL} ${tokens.spacingVerticalS}`,
    },
    cardBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalM,
        padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalL} ${tokens.spacingVerticalL}`,
    },
    tile: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: '40px',
        height: '40px',
        borderRadius: tokens.borderRadiusXLarge,
        fontSize: '20px',
    },
    tileSmall: {
        width: '28px',
        height: '28px',
        borderRadius: tokens.borderRadiusCircular,
        fontSize: '16px',
    },
    brand: {
        backgroundColor: tokens.colorBrandBackground2,
        color: tokens.colorBrandForeground1,
    },
    success: {
        backgroundColor: tokens.colorPaletteGreenBackground2,
        color: tokens.colorPaletteGreenForeground2,
    },
    warning: {
        backgroundColor: tokens.colorPaletteYellowBackground2,
        color: tokens.colorPaletteYellowForeground2,
    },
    danger: {
        backgroundColor: tokens.colorPaletteRedBackground2,
        color: tokens.colorPaletteRedForeground2,
    },
    neutral: {
        backgroundColor: tokens.colorNeutralBackground3,
        color: tokens.colorNeutralForeground2,
    },
    // Dois por linha já num celular; quatro numa tela larga.
    stats: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: tokens.spacingHorizontalL,
    },
    stat: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: tokens.spacingHorizontalM,
        padding: tokens.spacingHorizontalL,
    },
    statText: { display: 'flex', flexDirection: 'column', minWidth: 0 },
    statLabel: {
        color: tokens.colorNeutralForeground3,
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase200,
    },
    statValue: {
        fontSize: tokens.fontSizeHero700,
        lineHeight: tokens.lineHeightHero700,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
        fontVariantNumeric: 'tabular-nums',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    statValueText: {
        fontSize: tokens.fontSizeBase500,
        lineHeight: tokens.lineHeightBase500,
    },
});
/** Superfície arredondada que agrupa cada seção de conteúdo da página. */
export function Card({ title, headerAside, padded = false, className, children, }) {
    const styles = useStyles();
    return (_jsxs("section", { className: mergeClasses(styles.card, className), children: [(title !== undefined || headerAside !== undefined) && (_jsxs("div", { className: styles.cardHeader, children: [title !== undefined && _jsx(Subtitle2, { as: "h2", children: title }), headerAside] })), padded ? _jsx("div", { className: styles.cardBody, children: children }) : children] }));
}
/** Ícone sobre fundo tonal: identifica módulos, pessoas e indicadores. */
export function IconTile({ tone = 'brand', size = 'medium', children, }) {
    const styles = useStyles();
    return (_jsx("span", { className: mergeClasses(styles.tile, size === 'small' && styles.tileSmall, styles[tone]), "aria-hidden": true, children: children }));
}
/** Linha de indicadores no topo da página. */
export function StatRow({ stats }) {
    const styles = useStyles();
    return (_jsx("div", { className: styles.stats, children: stats.map(({ label, value, icon, tone }) => (_jsxs("div", { className: mergeClasses(styles.card, styles.stat), children: [_jsx(IconTile, { ...(tone === undefined ? {} : { tone }), children: icon }), _jsxs("div", { className: styles.statText, children: [_jsx("span", { className: styles.statLabel, children: label }), _jsx("span", { className: mergeClasses(styles.statValue, typeof value === 'string' && styles.statValueText), children: value })] })] }, label))) }));
}
//# sourceMappingURL=Surface.js.map